import { Modal } from "antd";
import { notify } from "@/shared/utils/notify";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import React from "react";
import { TableProperties } from "../../../shared/components/ui/Table/types";
import { storesService } from "../../../shared/services";

const { confirm } = Modal;

export const useDeleteStore = () => {
  const [tableProps, setTableProps] = React.useState<TableProperties>();

  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `¿Eliminar la sede ${valId}?`,
      icon: <ExclamationCircleOutlined />,
      content: `Se desactivará "${val}". Esta acción no se puede deshacer.`,
      okText: "Eliminar sede",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        await storesService
          .remove(valId)
          .then(() => {
            notify.success(`Sede ${valId} eliminada`);
            tableProps?.refresh();
          })
          .catch((err) => {
            notify.error(err?.message ?? "Error al eliminar");
          });
      },
      onCancel() {},
    });
  };

  return {
    tableProps,
    showDeleteConfirm,
    setTableProps,
  };
};
